<template>
  <div class="plus card-block">
    <img src="/img/plus.svg" alt="">
    <span class="mt35">{{plusName}}</span>
    <router-link :to="{name: `${namePage}-new`}" class="block__link"></router-link>
  </div>
</template>

<script>
  export default {
    name: "Plus",
    props: {
      namePage: {
        type: String,
        required: true
      },
      plusName: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss">
  @import "../style/var";

  .plus {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 55px 20px 20px;
    height: 260px;
    font-size: 24px;
    color: #ffffff;
    text-transform: uppercase;
    text-align: center;
    font-weight: 500;
    background-color: $blue;
    transition: $transition;
    &:hover {
      background-color: darken($blue, 5);
    }
    @media (max-width: 767px) {
      height: 190px;
      padding: 35px 20px 20px;
      font-size: 20px;
      img {
        max-width: 55px;
        margin-bottom: -10px;
      }
    }
  }
</style>